export default {
  state: {
    pageHistory:[]
  },
  getters: {
    getPageHistory(state) {
      return state.pageHistory;
    }
  },
  mutations: {
    CLEAR_PAGE_HISTORY(state) {
      state.pageHistory = [];
    },
    ADD_PAGE_HISTORY(state, pageHistory) {
      state.pageHistory.push(pageHistory);
    },
    DEL_PAGE_HISTORY(state, index) {
      state.pageHistory.splice(index, 1);
    }
  },
  actions: {}
};



// WEBPACK FOOTER //
// ./src/store/statistics/statistics.js